module["exports"] = [
  "Россия"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ru/address/default_country.js
 ** module id = 904
 ** module chunks = 0
 **/